










import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class SelectAnimationComponent extends Vue {
  @Prop({ required: true })
  value!: number;
  isShow = false;
  close() {
      this.isShow = false;
  }
}
